import React from 'react';
import { Record } from 'immutable';

// Types
import { WorkspaceMeetingMode } from 'Shared/types/WorkspaceMeetingMode.type';

// Hooks
import { useMeetingModeTracking } from 'Shared/tracking/use-meeting-mode-tracking';

// Helpers
import WorkspaceMeetingModeHelper from 'Shared/model_helpers/WorkspaceMeetingMode.helper';

// Components
import AgendaListItem from './AgendaListItem';
import { WpMenu, WpMenuItem } from 'Wpds/components/menu';

// Styles
import './AgendaList.scss';

type Props = {
  meetingItemOrderedKeys: Array<string>;
  meetingModeSession: Record<WorkspaceMeetingMode>;
  handleNavigateToItem: Function;
  showLabel?: boolean;
};

const AgendaList = ({ meetingItemOrderedKeys, meetingModeSession, handleNavigateToItem, showLabel = true }: Props) => {
  const { trackAgendaItemClick } = useMeetingModeTracking();

  const meetingItemId = WorkspaceMeetingModeHelper.getWorkspaceMeetingItemUuid(meetingModeSession);

  const handleMenuItemClick = uuid => {
    trackAgendaItemClick({ isWrapUp: uuid === 'wrapup' });
    handleNavigateToItem(uuid);
  };

  const baseClassName = 'AgendaList';

  return (
    <div className={baseClassName}>
      {showLabel && <p className={`${baseClassName}__title`}>Agenda</p>}
      <div className={`${baseClassName}__list`}>
        <WpMenu activeItemId={meetingItemId} onMenuItemClick={handleMenuItemClick}>
          {meetingItemOrderedKeys.map(item => {
            return (
              <WpMenuItem key={item} menuItemId={item}>
                <AgendaListItem meetingItemUuid={item} />
              </WpMenuItem>
            );
          })}
          <WpMenuItem menuItemId="wrapup">Wrap up</WpMenuItem>
        </WpMenu>
      </div>
    </div>
  );
};

export default AgendaList;
